import { PublicTenantSchema } from "../../models/tenant.schema";

export const TenantControllerResponseSchema = {
  getPublicTenant: PublicTenantSchema.nullable(),
};
